import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ComboDetail from '../components/ComboDetail';

const ComboDetailPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ComboDetail />
      </main>
      <Footer />
    </div>
  );
};

export default ComboDetailPage;
